import React from 'react'
import { ContactBanner } from "../../assets"
import Form from "./Form"
import { Banner, Nav, Footer } from '../../components'
import { motion } from "framer-motion";


function ContactUs() {
    return (
        <motion.div
            transition={{ duration: 1.2 }}
            exit={{ filter: ' brightness(0) ', }}
            className='homePage'
        >
            <Nav k={'4'} bgBlackTransparent />
            <Banner img={ContactBanner} />
            <main>
                {/* <Section1 data={data[1]} /> */}
                <Form />
            </main>
            <Footer />
        </motion.div>)
}

export default ContactUs